import { HStack, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export type SectionLabelProps = {
  icon?: IconType;
  title: string;
};

// 區段標題：不同區段的內容可以用props傳不同的icon跟標題內文
export default function SectionLabel({ icon, title }: SectionLabelProps) {
  return (
    <HStack>
      <Icon as={icon} boxSize="1.125rem" color="gray.500" />
      <Text fontSize="sm" letterSpacing={2} color="gray.500">
        {title}
      </Text>
    </HStack>
  );
}
